var React = require('react');

function Cloud (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M640 352a128 128 0 0 1-128 128H144a144 144 0 0 1-47.8-279.9c-.1-2.7-.2-5.4-.2-8.1a160 160 0 0 1 298.7-79.8A95.95 95.95 0 0 1 544 192a96.66 96.66 0 0 1-6.4 34.6A128 128 0 0 1 640 352z","className":"fa-primary","key":1})]);
}

Cloud.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Cloud;

Cloud.default = Cloud;
